<template>
    <vs-chip v-if="params.value != null" class="ag-grid-cell-chip" :color="chipColor(params.value)">
        <span>{{ status(params.value) }}</span>
    </vs-chip>
</template>

<script>
    export default {
        name: 'CellRendererStatus',
        computed: {
            chipColor() {
                return (value) => {
                    if (value === 1) return 'success'
                    else if (value === 0) return 'danger'
                    else return 'dark'
                }
            },
            status() {
                return (value) => {
                    if (value === 1) return 'Active';
                    else if (value === 0) return 'Inactive';
                    else return 'null';
                }
            },
        }
    }
</script>
